export class CategoryItem {
    categoryId: number;
    customerItemId: number;
}
